'use strict';

/*#__NO_SIDE_EFFECTS__*/
function memo(callback) {
    let result;
    return () => {
        if (result === undefined)
            result = callback();
        return result;
    };
}

exports.memo = memo;
//# sourceMappingURL=memo.cjs.map
